import idb from "@/plugins/indexdb.js";
import DropdownsRepository from "../../repositories/dropdownsRepository";

export default {
  namespaced: true,
  state: {
    dropdowns: []
  },
  mutations: {
    // Set dropdowns
    SET_DROPDOWNS(state, dropdowns) {
      state.dropdowns = dropdowns;
    },

    // Clean dropdowns object
    cleanDropdowns(state) {
      state.dropdowns = [];
    }
  },
  actions: {
    // Get all dropdowns from api
    async getDropdowns({ commit }) {
      try {
        const { data } = await DropdownsRepository.get();
        commit("SET_DROPDOWNS", data);

        let dropdowns = [];

        // Add manual id for IndexedDB
        data.id = 1;
        dropdowns.push(data);

        await idb.db.dropdowns.bulkPut(dropdowns);
      } catch (error) {
        throw error;
      }
    },

    async getLocalDropdowns({ commit }) {
      try {
        const dropdowns = await idb.db.dropdowns.toArray();
        commit("SET_DROPDOWNS", dropdowns);
        return;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    // Get product dropdowns from IndexedDB
    async getLocalDropdownsByProduct(context, product) {
      try {
        const dropdowns = await idb.db.dropdowns.toArray();
        return dropdowns[0][product];
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticle(context, article_id) {
      try {
        const res = await idb.db.articles.get(article_id);
        return res;
      } catch (error) {
        throw error;
      }
    },

    // Get local articles from IndexedDB
    async getLocalArticlesByModel(context, model) {
      try {
        const res = await idb.db.articles
          .where({ product_model: model })
          .toArray();

        return res.sort((a, b) => {
          if (a.order) {
            a.order - b.order;
          }
        });
      } catch (error) {
        throw error;
      }
    },

    // Clean store
    cleanArticles({ commit }) {
      commit("setDropdowns", []);
    }
  },
  getters: {
    getMoldedSeatOptions: state => {
      return state.dropdowns[0]["product_molded_seat"];
    },

    getLiftOptions: state => {
      return state.dropdowns[0]["product_lift"];
    },

    getOtnOptions: state => {
      return state.dropdowns[0]["product_otn"];
    },

    getCorsetOptions: state => {
      return state.dropdowns[0]["product_corset"];
    },

    getSeatOptions: state => {
      return state.dropdowns[0]["product_seat"];
    },

    getLowerLimbOptions: state => {
      return state.dropdowns[0]["product_lower_limb_orthosis"];
    },

    getUpperLimbOptions: state => {
      return state.dropdowns[0]["product_upper_limb_orthosis"];
    },

    getBreastPlateOptions: state => {
      return state.dropdowns[0]["breastplate_module"];
    },

    getHeadRestOptions: state => {
      return state.dropdowns[0]["headrest_module"];
    },

    getSocleOptions: state => {
      return state.dropdowns[0]["socle_module"];
    },

    getArmRestOptions: state => {
      return state.dropdowns[0]["armrest_module"];
    },

    getLegSegmentOptions: state => {
      return state.dropdowns[0]["leg_segment_module"];
    },

    getPedalSegmentOptions: state => {
      return state.dropdowns[0]["pedal_segment_module"];
    }
  }
};
